import React from 'react';
import classNames from 'classnames';

import useApi from 'common/useApi';
import roundToGivenDecimals from 'common/roundToGivenDecimals';

import './EstimatedEarnings.scss';

// Expected (luck-independent) daily earnings: the account's share of the network
// hashrate times the daily block budget and subsidy, less the pool fee. It's a
// projection — it excludes transaction fees and price moves.
const EstimatedEarnings = () => {
  const { data, isLoading, isFetching } = useApi(
    'get',
    '/api/dashboard/earnings-estimate',
  );

  const dailyBtc = roundToGivenDecimals(parseFloat(data?.estimated_daily_btc ?? '0'), 8);
  const usdRaw = data?.estimated_daily_usd;
  const dailyUsd = usdRaw ? roundToGivenDecimals(parseFloat(usdRaw), 2) : null;
  const monthlyBtc = roundToGivenDecimals(parseFloat(data?.estimated_daily_btc ?? '0') * 30, 8);

  // No hashrate yet (new account, or all workers offline) → there's nothing to
  // project, so show a prompt instead of a misleading 0.
  const noHashrate = !!data && parseFloat(data.user_hashrate ?? '0') === 0;

  return (
    <div className='estimated-earnings'>
      <h3>Estimated Earnings</h3>
      <div className={classNames({ box: true, isLoading: isLoading || isFetching, 'estimated-earnings-box': true })}>
        {noHashrate ? (
          <p className='estimate-empty'>
            Start mining to see a projection of your daily and monthly earnings.
          </p>
        ) : (
          <>
            <div className='estimate primary'>
              <h5>Projected Daily</h5>
              <h3>{dailyBtc} <span>BTC</span></h3>
              {dailyUsd !== null && <div className='in-dollars'>≈ {dailyUsd} USD</div>}
            </div>
            <div className='estimate'>
              <h5>Projected Monthly</h5>
              <h3>{monthlyBtc} <span>BTC</span></h3>
              <div className='in-dollars'>
                {dailyUsd !== null ? `≈ ${roundToGivenDecimals(dailyUsd * 30, 2)} USD` : ' '}
              </div>
            </div>
            <p className='estimate-note'>
          Expected value from your current hashrate share of the network — excludes
          variance (pool luck) and price changes.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default EstimatedEarnings;
